import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import { alerts } from 'app/components/global';
import editFindingCategoryDialog from './dialog.editFindingCategoryDialog';
import controller from './finding-categories.controller';
import directive from './finding-categories.directive';
import findingCategory from './findingCategory';


export default angular.module('app.components.advisory.auditTrail.findingCategories', [
  alerts,
  amDataService,
  amSharedModelService,
  constants,
  editFindingCategoryDialog,
  findingCategory,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('amFindingCategories', directive)
  .controller('FindingCategoriesController', controller)
  .name;

console.log('app.components.advisory.auditTrail.findingCategories created');
